import React from 'react';
import { ProgressBarContainer, StepContainer, StepNamePositioner, StepNameLabel, StepCircle, Spacer } from './styles';

const calculateStepStatus = (selectedStep, step) => {
	if (selectedStep === step) return 'active';
	if (selectedStep > step) return 'completed';
	return 'pending';
};

const ProgressBar = ({ steps, selectedStep }) => {
	const stepsQuantity = steps?.length;

	if (stepsQuantity) {
		return (
			<ProgressBarContainer>
				{steps.map((stepLabel, index) => {
					const isFirstStep = !index;
					const stepNumber = index + 1;
					const isLastStep = stepNumber === stepsQuantity;
					const stepStatus = calculateStepStatus(selectedStep, stepNumber);

					let labelPosition = 'center';
					if (isFirstStep) labelPosition = 'flex-start';
					if (isLastStep) labelPosition = 'flex-end';

					return (
						<React.Fragment key={`step-spacer-${index}`}>
							{!isFirstStep && <Spacer key={`spacer-${index}`} status={stepStatus} />}
							<StepContainer key={`step-${index}`}>
								<StepCircle status={stepStatus}>{stepNumber}</StepCircle>
								<StepNamePositioner position={labelPosition}>
									<StepNameLabel>{stepLabel}</StepNameLabel>
								</StepNamePositioner>
							</StepContainer>
						</React.Fragment>
					);
				})}
			</ProgressBarContainer>
		);
	}
};

export default ProgressBar;
